import { trackingApis } from '@apis/trackingDataApis';
import { createUseQuery } from '@hooks/createUseQuery';

export const useTrackingData = createUseQuery(
  (trackNo: string) => ['/dashboard/tracking-data/', trackNo],
  (trackNo) => () =>
    trackingApis
      .get('/tracking-data/{track_no}/', {
        path: { track_no: trackNo },
      })
      .then((r) => r[200] ?? r[404]),
);
